import { Form, Formik } from 'formik'
import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Loading from 'custom/assets/loaders/Loading'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import { useHistory } from 'react-router-dom'
import StatementIcon from 'custom/assets/accounts/Statement.svg'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import NeoCalendar from '../../components/NeoCalendar/NeoCalendar'
import DetailsIcon from 'custom/assets/accounts/Details.svg'
import './statement.css'
import { DETAILED_STATEMENT_KEYS, BUTTON_KEYS } from '../../utils/translation-constants'

export default function DetailedStatement() {
  const [error, setError] = useState('')
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(0)
  const [reportList, setReportList] = useState([])
  const formatList = ['xlsx', 'pdf']
  const history = useHistory()
  const [accounts, setAccounts] = useState([])
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [showDatePicker, setShowDatePicker] = useState(false)
  const [dateError, setDateError] = useState(false)

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderDetailOptions() {
    return (
      <div className='row mb-4 mx-0'>
        <div className='col-5'>
          <button
            tabIndex={'1'}
            type='button'
            className='btn detailed-statement-btn statement-option mb-3'
            onClick={() => history.push('/currentMonth')}>
            <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
            <span className='font-weight-600'>{t(DETAILED_STATEMENT_KEYS.CURRENT_MONTH_HEADER)}</span>
          </button>
        </div>
        <div className='col-7'>
          <button
            tabIndex={'2'}
            type='button'
            className='btn detailed-statement-btn  statement-option mb-3'
            onClick={() => history.push('/lastTwoMonth')}>
            <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
            <span className='font-weight-600'>{t(DETAILED_STATEMENT_KEYS.LAST_TWO_MONTH_HEADER)}</span>
          </button>
        </div>
        <div className='col-5'>
          <button
            tabIndex={'3'}
            type='button'
            className='btn  detailed-statement-btn statement-option  mb-3'
            onClick={() => history.push('/lastThreeMonth')}>
            <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
            <span className='font-weight-600'>{t(DETAILED_STATEMENT_KEYS.LAST_THREE_MONTH_HEADER)}</span>
          </button>
        </div>
        <div className='col-5'>
          <button
            tabIndex={'4'}
            type='button'
            className='btn  detailed-statement-btn statement-option  '
            onClick={() => setShowDatePicker(!showDatePicker)}>
            <img src={DetailsIcon} height={23} width={20} alt='' className='mr-2' />
            <span className='font-weight-600'>{t(DETAILED_STATEMENT_KEYS.CUSTOM_RANGE_HEADER)}</span>
          </button>
        </div>

        {showDatePicker && (
          <div className='col-12 text-center m-3 calender-container'>
            <NeoCalendar setFromDate={setFromDate} setToDate={setToDate} />
            <div>
              <NeoButton
                type='button'
                mode='newDesign'
                text={t(BUTTON_KEYS.OK)}
                styles={{ fontSize: 14, width: '247px' }}
                onClick={() => {
                  setShowDatePicker(false)
                  history.push({
                    pathname: '/customDates',
                    state: {
                      fromDate: fromDate,
                      toDate: toDate,
                    },
                  })
                }}
              />
              {dateError && (
                <div className='text-danger'>
                  {!fromDate && !toDate && t(DETAILED_STATEMENT_KEYS.FROM_DATE_SELECT)}
                  {fromDate && !toDate && t(DETAILED_STATEMENT_KEYS.TO_DATE_SELECT)}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
  return (
    <LayoutWithAccountCard breadCumKey='DETAILED_STATEMENT'>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={StatementIcon} alt='statement icon' />
          </div>
          <div className="title-spacing">
            <span className='font-weight-bold'>{t(DETAILED_STATEMENT_KEYS.HEADER)}</span>
            <span className='header-title-section'>
              <p>{t(DETAILED_STATEMENT_KEYS.DESCRIPTION)}</p>
            </span>
          </div>
        </div>
      </div>
      <div>{renderDetailOptions()}</div>
    </LayoutWithAccountCard>
  )
}
